import React from "react";

import Promenu from './Promenu';
import { Helmet } from "react-helmet";

function Home() {
    return (
        <div>


            <Helmet>
                <title>CodeExampler Learn Programming Tutorial for Beginners For Free</title>
                <meta name="description" content="CodeExampler Learn Programming tutorial for beginners for Free Learn interview Questions and learn lot of Examples for free,Free Online Tutorials for beginners like Java, Python, C, C++ ,C#, PHP, JavaScript tutorial for beginners learn interview Questions and learn lot of Examples " />
                <meta name="keywords" content="codeexampler,programming language,tutorial for beginners,Difference Between Java and Python,Difference between program and code,java tutorial for beginners,C# tutorial for beginners,Python tutorial for beginners,C tutorial for beginners, JavaScript tutorial for beginners,C++ tutorial for beginners,code,exampler,which online website to learn code,Difference Between Java and C# ,java vs c#,java vs python,free programming online website to learn Python, Java, C#, Csharp, JavaScript, PHP, C, C++" />
                <link rel="canonical" href="https://www.codeexampler.com/" />
            </Helmet>


            <Promenu />



        </div>


    )
}


export default Home;